module.exports = __webpack_public_path__ + "img/12-1.6826c9fe.png";